export default "__VITE_ASSET__Cn38IsLb__"